export const coverageSelectionValue = ( coverage = {} ) => JSON.stringify( [ coverage.carrier, coverage.account, coverage.group ] );

export const eligibleCoverageOptions = ( coverages = [] ) => ( coverages || [] ).map( coverage => ( {
    value: coverageSelectionValue( coverage ),
    title: { value: [ coverage.carrier, coverage.account, coverage.group ].filter( Boolean ).join( ' / ' ) }
} ) );

export const findEligibleCoverage = ( coverages = [], value ) => ( coverages || [] ).find(
    coverage => coverageSelectionValue( coverage ) === value
);

export const isEligibleCoverage = ( coverages = [], selectedCoverage = {} ) => Boolean(
    findEligibleCoverage( coverages, coverageSelectionValue( selectedCoverage ) )
);

export const buildReactivateRequestPayload = ( requestPayload = {}, data = {}, hasLiveCoverageOptions = false ) => {
    const selectedCoverage = data.insurance || {};
    const context = hasLiveCoverageOptions ? {
        carrierId: selectedCoverage.carrier,
        accountId: selectedCoverage.account,
        groupId: selectedCoverage.group,
    } : {};

    return {
        ...requestPayload,
        context: { ...( requestPayload.context || {} ), ...context },
        data,
    };
};
